import React, { useState } from "react";
import { Link } from "react-router-dom";
import Image from "../../../elements/Image";
import { getBlogList } from "../../../../services/BlogService";
import useFetch from "../../../../hooks/useFetch";
import dayjs from "dayjs";
import { removeDuplicateFromArray, replaceOldData } from "../../../../helpers";
import Noimage from "../../../../assets/images/no-image-available.png";
import { classNames } from "../../../../helpers/classNames";

const BlogAsideItem = ({ data }) => {
  return (
    <>
      <Link to={data?.link} className="block md:flex items-center gap-4 xls:gap-8">
        <div className="w-full lg:w-24 md:w-32 xls:w-40 aspect-[3/2] flex-shrink-0 overflow-hidden bg-shades-04">
          <Image
            src={data?.image || Noimage}
            alt={""}
            effect="blur"
            classes={classNames(
              "object-cover",
              !data?.image ? "scale-[0.4]" : ""
            )}
          />
        </div>
        <div className="flex-shrink flex-grow">
          {data?.title && (
            <h2 className="text-sm xls:text-xl text-chestnut-rose font-medium line-clamp-3">
              {data?.title}
            </h2>
          )}
        </div>
      </Link>
    </>
  );
};

const BlogsAside = () => {
  const [query, setQuery] = useState({
    limit: 10,
    sortQuery: "-createdAt",
  });

  const {
    data: BlogsData,
    error,
    isLoading,
    updateData,
    isFetching,
    refetch,
  } = useFetch({
    dependencies: ["font-blogs", query],
    fetchFunction: async () => {
      const res = await getBlogList({
        type: "blog",
        ...query,
      });
      if (res?.docs?.status === 200) {
        const blogArr = (res?.docs?.data || [])
          ?.filter((item) => item?.title)
          ?.map((item) => ({
            ...item,
            _id: item?._id,
            date: {
              day: dayjs(item?.publishDate)?.format("DD"),
              month: dayjs(item?.publishDate)?.format("MMMM"),
            },
            image: item?.image?.url,
            link: `/blogs/${item?.slug || item?._id}`,
          }));

        const newArr = replaceOldData([...(BlogsData?.data || [])], blogArr);

        return {
          ...res?.docs,
          data: removeDuplicateFromArray([...newArr, ...blogArr]),
        };
      } else {
        if (BlogsData?.data?.length > 0) {
          return BlogsData;
        } else {
          return res;
        }
      }
    },
  });

  return (
    <>
      <div className="sticky top-44 bg-shades-03 py-8 px-5 md:px-10 space-y-8 mb-auto w-full">
        <h2 className="text-3xl font-bold">All Blog</h2>
        {BlogsData?.data?.length > 0 && (
          <div className="space-y-6 overflow-auto max-h-svh scrollbar xls:pr-6">
            {BlogsData?.data?.map((item, index) => (
              <BlogAsideItem key={index} data={item} />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default BlogsAside;
